/*************************************
 State
 **/
const state = {
	socket: null,
	lastMessage: null,
};

/*************************************
 Getters
 **/
const getters = {
	/**
	 * get socket state
	 * @param {*} state
	 */
	getSocketState: function (state) {
		if (state.socket === null) return false;
		return state.socket.readyState;
	},
	getSocketReadyState: function (state) {
		if (state.socket === null) return -1;
		return state.socket.readyState;
	},

	/**
	 * get socket
	 * @param {*} state
	 */
	getSocket: function (state) {
		if (state.socket === null || !state.socket.readyState) return false;
		return state.socket;
	},
	/**
	 * get socket
	 * @param {*} state
	 */
	getLastMessage: function (state) {
		return state.lastMessage;
	},
};

/*************************************
 Mutations
 **/
const mutations = {
	setLastMessage(state, datas) {
		state.lastMessage = datas;
	},
};

/*************************************
 Action
 **/
const actions = {
	/**
	 * Create Socket
	 * @param {*} store params
	 */
	async createSocketConnection({ state, rootState, commit, dispatch }) {
		dispatch("forceCloseSocket");
		// clean socket
		state.socket = null;
		// create connection
		state.socket = new WebSocket(import.meta.env.VITE_WS_URL);
		dispatch("openSocketHandler");
	},

	async forceCloseSocket({ state, rootState, commit, dispatch }) {
		if (state.socket !== null) {
			await state.socket.close();
		}
	},

	/**
	 * Open Socket
	 * @param {*} store params
	 */
	openSocketHandler: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		let uid = rootGetters["newUsers/getUidPublic"];
		state.socket.onopen = function () {
			console.info("webSocket connection open");
			if (getters["getSocketState"]) {
				// send resto id to server
				state.socket.send(
					JSON.stringify({
						event: "connect",
						data: uid,
					}),
				);
				dispatch("closeSocketHandler");
				dispatch("errorSocketHandler");
				state.socket.onmessage = (data) => {
					commit("setLastMessage", data);
				};
			}
		};
	},

	/**
	 * Close Socket
	 * @param {*} store params
	 */
	closeSocketHandler: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		state.socket.onclose = function () {
			// clear socket object
			state.socket = null;
		};
	},

	/**
	 * checkSocketConnection
	 */
	checkSocketConnection: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		if (!getters["getSocketState"]) {
		}
	},

	/**
	 * erros webSocket
	 */
	errorSocketHandler: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		state.socket.onerror = function (event) {
			console.error("Socket Error : ", event);
		};
	},

	/**
	 * send webSocket update for restoid
	 */
	sendSocketUpdateMessage: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		let uid = rootGetters["newUsers/getUidPublic"];
		if (getters["getSocketState"]) {
			state.socket.send(
				JSON.stringify({
					event: "update",
					data: uid,
				}),
			);
		} else {
			console.error("socket message didn't sended socket state is off");
		}
	},
	/**
	 * send webSocket update for restoid
	 */
	sendPing: function ({
		state,
		rootState,
		commit,
		dispatch,
		getters,
		rootGetters,
	}) {
		if (getters["getSocketState"]) {
			state.socket.send(
				JSON.stringify({
					event: "ping",
					data: {},
				}),
			);
		} else {
			console.error("socket ping didn't sended socket state is off");
		}
	},
};

/*************************************
 Export module
 **/
export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
